<template>
<div class="payment_component">
    <section class="">
        <div class="inner">

        <!-- <layout v-bind:user="user"  v-bind:shops="shops" v-bind:brands="brands" v-bind:company="company" title="ブランド ダッシュボード" @selectList="displaySelectedBrand($event)"> -->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Logo
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="logo-element">
            <img src="/img/logo/logo-auma-black.svg" alt="">
        </div>

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Heading
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <h1 class="heading_page-title flex _y-center">
            <div class="main"><span>{{ brand.name }} 様 | プラン選択</span></div>
        </h1><!--/.heading_page-title-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            DashBoardCardWrap
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="card_plan-select-container">
            <div class="card_plan-select-wrap" v-if="brand.type == 1">

                <!--Card-->
                <div class="card">
                    <div class="title"><p class="main"><span>Free</span></p></div>
                    <div class="price">
                        <span>0</span>
                        <div>/ 月</div>
                    </div>
                    <div class="comment">
                        <p>無料なので誰でも簡単登録</p>
                    </div>
                    <ul>
                        <li><span>商品ブランドの紹介</span></li>
                        <li class="_disable"><span>Price Image10枚登録可能</span></li>
                        <li class="_disable"><span>制作スタッフの紹介</span></li>
                        <li class="_disable"><span>ハッシュタグ検索</span></li>
                        <li class="_disable"><span>電話又はメールのお問い合わせ機能搭載</span></li>
                        <li class="_disable"><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li class="_disable"><span>チャット機能でショップへ情報の発信可能</span></li>
                    </ul>
                    <!-- <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>Freeアカウントで登録する</span>
                        </div>
                    </Link> -->
                </div><!--/.Card-->

                <!--Card-->
                <div class="card _main">
                    <div class="title"><p class="main"><span>BASIC</span></p></div>
                    <div class="price">
                        <span>4,950</span>
                        <div>/ 月</div>
                    </div>
                    <div class="comment">
                        <p>ビジネスに繋がる情報掲載！販促予算の無い方におすすめ。マイセレクトルームで、ショップ側からのアプローチが実現！チャット機能で展示会情報やショップ側の情報などを確認できます。</p>
                    </div>
                    <ul>
                        <li><span>商品ブランドの紹介</span></li>
                        <li><span>Price Image10枚登録可能</span></li>
                        <li><span>制作スタッフの紹介</span></li>
                        <li><span>ハッシュタグ検索</span></li>
                        <li><span>電話又はメールのお問い合わせ機能搭載</span></li>
                        <li><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li><span>チャット機能でショップへ情報の発信可能</span></li>
                    </ul>
                    <button class="btn_link md_icon-text _white" v-on:click="basic(brand.id)">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>Basicプランへアップグレードする</span>
                        </div>
                    </button>
                </div><!--/.Card-->

                <!--Card-->
                <div class="card _soon">
                    <div class="title">
                        <p class="main"><span>Premium</span></p>
                        <p class="sub">Coming Soon</p>
                    </div>
                </div><!--/.Card-->

            </div><!--/.card_plan-select-->

            <div class="card_plan-select-wrap" v-if="brand.type == 2">

                <!--Card-->
                <div class="card _soon">
                    <div class="title">
                        <p class="main"><span>Free</span></p>
                        <p class="sub">Coming Soon</p>
                    </div>
                </div><!--/.Card-->

                <!--Card-->
                <div class="card _main">
                    <div class="title"><p class="main"><span>BASIC</span></p></div>
                    <div class="price">
                        <span>11,000</span>
                        <div>/ 月</div>
                    </div>
                    <div class="comment">
                        <p>ビジネスに繋がる情報掲載！販促予算の無い方におすすめ。マイセレクトルームで、ショップ側からのアプローチが実現！チャット機能で展示会情報やショップ側の情報などを確認できます。</p>
                    </div>
                    <ul>
                        <li><span>商品ブランドの紹介</span></li>
                        <li><span>Price Image10枚登録可能</span></li>
                        <li><span>制作スタッフの紹介</span></li>
                        <li><span>ハッシュタグ検索</span></li>
                        <li><span>電話又はメールのお問い合わせ機能搭載</span></li>
                        <li><span>マイセレクトルーム（お気に入り機能）でビジネス対象のリスト確認ができる</span></li>
                        <li><span>チャット機能でショップへ情報の発信可能</span></li>
                    </ul>
                    <button class="btn_link md_icon-text _white" v-on:click="basic(brand.id)">
                        <div class="inner">
                            <span><div class="icon"><SvgIconCheck /></div>Basicプランへアップグレードする</span>
                        </div>
                    </button>
                </div><!--/.Card-->

                <!--Card-->
                <div class="card _soon">
                    <div class="title">
                        <p class="main"><span>Premium</span></p>
                        <p class="sub">Coming Soon</p>
                    </div>
                </div><!--/.Card-->
            </div>

        </div><!--/.DashBoardCardWrap-->

        <!--:::::::::::::::::::::::::::::::::::::::::::::::
            Button
        :::::::::::::::::::::::::::::::::::::::::::::::::-->
        <div class="btn_link-wrap" v-if="brand.type == 1">

            <Link v-if="user.type == 0" class="btn_link _cancel _none md_icon-text" :href="route('admin.brand.list')" :data="{company_id: this.brand.company_id}" as="button">
                <div class="inner">
                    <span><div class="icon"><SvgIconBack /></div>ブランド一覧へ戻る</span>
                </div>
            </Link>
            <Link v-if="user.type != 0" class="btn_link _cancel _none md_icon-text" :href="route('admin.brand.list')" as="button">
                <div class="inner">
                    <span><div class="icon"><SvgIconBack /></div>ブランド一覧へ戻る</span>
                </div>
            </Link>

            <button class="btn_link md_icon-text _white" v-on:click="portal(brand.id)">
                <div class="inner">
                    <span><div class="icon"><SvgIconReload /></div>プランの変更またはキャンセルはこちら</span>
                </div>
            </button>

        </div><!-- /.BtnLinkWrap -->

        <div class="btn_link-wrap" v-if="brand.type == 2">

            <Link v-if="user.type == 0" class="btn_link _cancel _none md_icon-text" :href="route('admin.showroom.list')" :data="{company_id: this.brand.company_id}" as="button">
                <div class="inner">
                    <span><div class="icon"><SvgIconBack /></div>ショールーム一覧へ戻る</span>
                </div>
            </Link>
            <Link v-if="user.type != 0" class="btn_link _cancel _none md_icon-text" :href="route('admin.showroom.list')" as="button">
                <div class="inner">
                    <span><div class="icon"><SvgIconBack /></div>ショールーム一覧へ戻る</span>
                </div>
            </Link>

            <button class="btn_link md_icon-text _white" v-on:click="portal(brand.id)">
                <div class="inner">
                    <span><div class="icon"><SvgIconReload /></div>プランの変更またはキャンセルはこちら</span>
                </div>
            </button>

        </div><!-- /.BtnLinkWrap -->

    <!-- </layout> -->
    </div>
</section>


<!--:::::::::::::::::::::::::::::::::::::::::::::::
    ModalValidation
:::::::::::::::::::::::::::::::::::::::::::::::::-->
<div class="modal_container ModalValidation" v-bind:class="{_open: isOpen}">
    <div class="modal_wrap">

        <!-- Title -->
        <div class="modal_title">
            <h3><span>{{ brand.name }} 様</span></h3>
        </div>

        <!-- Body -->
        <div class="modal_body">
            <div class="inner">
                <p>{{ modalBody }}</p>
            </div>
        </div>

        <!--btn-link-wrap-->
        <div class="btn_link-wrap">

            <button class="btn_link md_icon-text _white js-modal-close" v-on:click="closeModal">
                <div class="inner">
                    <span><div class="icon"><SvgIconCheck /></div>OK</span>
                </div>
            </button>

        </div><!--/.btn-link-wrap-->

    </div>
    <div class="modal_close-ovl js-modal-close"></div>
</div>

    <ConfirmModalWithPromise ref="confirmModal" />

<!-- </layout> -->
<!--:::::::::::::::::::::::::::::::::::::::::::::::
    ModalBackGround
:::::::::::::::::::::::::::::::::::::::::::::::::-->
<div class="modal_bg" v-bind:class="{_on: isOpen}"></div>
</div>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import { Inertia } from '@inertiajs/inertia'
    import { Link } from '@inertiajs/inertia-vue3'
    import ConfirmModalWithPromise from '@/components/Admin/ComponentList/ConfirmModalWithPromise'

    //Svg
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'
    import SvgIconReload from '@/components/EndUser/svg/SvgIconReload'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            "layout": AdminLayout,
            "Link": Link,
            "ConfirmModalWithPromise": ConfirmModalWithPromise,
            // svg
            SvgIconCheck,
            SvgIconReload,
            SvgIconBack,
        },
        data() {
            return {
                isOpen: false,
                modalBody: '',
            }
        },
        mounted() {
            var param = this.getParam('plan');
            if (param == 'entry-basic') {
                this.modalBody = 'ベーシックプランへのお申込ありがとうございます。お申込の反映までに少しお時間がかかる場合がございます。';
                this.isOpen = true;
            } else if (this.plan) {
                switch (this.plan) {
                    case 'basic':
                        this.modalBody = '既にベーシックプランへご加入中です。';
                        this.isOpen = true;
                        break;
                    case 'before':
                        this.modalBody = 'ご加入中の有償プランはまだありません。';
                        this.isOpen = true;
                        break;
                }
            }
        },
        props: {
            user: Object,
            plan: String,
            brand: Object,
        },
        methods: {
            async basic(id) {
                if (this.brand.type == 1) {
                    location.href = '/admin/brand/manager/payment/basic-plan/' + id;
                } else if (this.brand.type == 2) {
                    location.href = '/admin/showroom/manager/payment/basic-plan/' + id;
                }
                // const confirm = await this.$refs.confirmModal.show({ // 確認済み
                //     title: 'お申し込み画面へ進みますか？',
                //     message: 'ベーシックプランのお申し込み画面へ進みますか？',
                //     mode: "confirm",
                //     name: "paymentConfirm"
                // })
                // if (confirm) {
                //     if (this.brand.type == 1) {
                //         location.href = '/admin/brand/manager/payment/basic-plan/' + id;
                //     } else if (this.brand.type == 2) {
                //         location.href = '/admin/showroom/manager/payment/basic-plan/' + id;
                //     }
                // }
            },
            async portal(id) {
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '変更・キャンセル画面へ進みますか？お申し込み画面へ進みますか？',
                    message: 'プランの変更・キャンセル画面へ進みますか？',
                    mode: "confirm",
                    name: "paymentConfirm"
                })
                if (confirm) {
                    if (this.brand.type == 1) {
                        location.href = '/admin/brand/manager/payment/portal/' + id;
                    } else if (this.brand.type == 2) {
                        location.href = '/admin/showroom/manager/payment/portal/' + id;
                    }
                }
            },
            getParam(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            closeModal() {
                this.isOpen = false;
                this.modalBody = '';
            },
        },
    }
</script>
